import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';

import * as rawJSONSchemaModuleCancerOvarian from '../../schemas/module-cancer-ovarian.json';

class ModuleValueCancerOvarian extends ModuleValueGeneral {
  main_procedure?: string;
  date_of_birth?: string;
  date_of_diagnosis?: string;
  date_of_surgery?: string;
  date_last_follow_up?: string;
  start_date_neoadjuvant?: string;
  recurrence_progression?: boolean;
  recurrence_progression_date?: string;
  progression_free_survival_duration?: number;
  follow_up_duration?: number;
  follow_up_duration_compute?: boolean;
  survival?: number;
}

export class SchemaModuleCancerOvarian extends SchemaModuleGeneral<ModuleValueCancerOvarian> {
  schema: JSONSchema<ModuleValueCancerOvarian>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleCancerOvarian );
  }

  hook( form: FormComponent ) {
    super.hook( form );

    this.listenValue(
      [ 'recurrence_progression_date', 'main_procedure', 'date_of_surgery', 'start_date_neoadjuvant' ],
      this.fieldHandlerCalculateProgressionFreeSurvival.bind( this )
    );

    this.listenValue(
      [ 'date_last_follow_up', 'main_procedure', 'date_of_surgery', 'start_date_neoadjuvant' ],
      this.fieldHandlerCalculateFollowUpDuration.bind( this )
    );

    this.listenValue( 'follow_up_duration_compute', this.fieldHandlerFollowUpDurationCompute.bind( this ) );

    this.listenValue(
      [ 'date_last_follow_up', 'main_procedure', 'date_of_surgery', 'start_date_neoadjuvant' ],
      this.fieldHandlerCalculateSurvival.bind( this )
    );
  }

  setupValidators() {
    super.setupValidators();

    this.validatorDateComparison( 'date_of_birth', 'date_of_diagnosis', '<' );
    this.validatorDateComparison( 'date_of_diagnosis', 'date_of_surgery', '<=' );
    this.validatorDateComparison( 'date_of_diagnosis', 'date_last_follow_up', '<' );
    this.validatorDateComparison( 'date_of_diagnosis', 'recurrence_progression_date', '<=' );

    this.validatorDate( 'date_of_birth', ( new Date() ), '<=' , v => new Date( v as any ));
    this.validatorDate( 'date_of_diagnosis', ( new Date() ), '<=' , v => new Date( v as any ));
  }

  fieldHandlerCalculateProgressionFreeSurvival(
    recurrenceDate: string,
    mainProcedure: string,
    surgeryDate: string,
    neoadjuvantStartDate: string,
  ) {
    const startDate = this.resolveStartDate( mainProcedure, surgeryDate, neoadjuvantStartDate );
    this.updateValue( 'progression_free_survival_duration', this.diffInMonths( recurrenceDate, startDate, 30.25 ) );
  }

  fieldHandlerCalculateFollowUpDuration(
    followUpDate: string,
    mainProcedure: string,
    surgeryDate: string,
    neoadjuvantStartDate: string,
  ) {
    if ( !this.getValue( 'follow_up_duration_compute' ) ) return;
    const startDate = this.resolveStartDate( mainProcedure, surgeryDate, neoadjuvantStartDate );
    this.updateValue( 'follow_up_duration', this.diffInMonths( followUpDate, startDate, 30.5 ) );
  }

  fieldHandlerFollowUpDurationCompute( compute: boolean ) {
    if ( typeof compute === 'undefined' || compute === null ) return;
    this.schema.properties[ 'follow_up_duration' ].readOnly = compute;

    if ( compute ) {
      this.fieldHandlerCalculateFollowUpDuration(
        this.getValue( 'date_last_follow_up' ),
        this.getValue( 'main_procedure' ),
        this.getValue( 'date_of_surgery' ),
        this.getValue( 'start_date_neoadjuvant' ),
      );
    }
  }

  fieldHandlerCalculateSurvival(
    followUpDate: string,
    mainProcedure: string,
    surgeryDate: string,
    neoadjuvantStartDate: string,
  ) {
    const startDate = this.resolveStartDate( mainProcedure, surgeryDate, neoadjuvantStartDate );
    this.updateValue( 'survival', this.diffInMonths( followUpDate, startDate, 30.5 ) );
  }

  private resolveStartDate(
    mainProcedure: string,
    surgeryDate: string,
    neoadjuvantStartDate: string,
  ): string {
    if ( mainProcedure === 'neoadjuvant_chemotherapy' ) return neoadjuvantStartDate;
    return surgeryDate;
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-cancer-ovarian.ts